var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarMaargIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 47 40.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{mix-blend-mode:multiply;opacity:0.75;}.cls-3{fill:none;stroke-width:2px;}.cls-3,.cls-5{stroke:#fff;stroke-miterlimit:10;}.cls-4{fill:#fff;}.cls-5{fill:#b499c7;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Feedback_Mentor_and_Startup",
    "data-name": "Feedback Mentor and Startup"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-2",
    width: 47,
    height: 39,
    transform: "translate(0 1.9)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAnCAYAAACfdBHBAAAACXBIWXMAAAsSAAALEgHS3X78AAACqElEQVRYR+3ZzW8TVxQF8J8dhwYKyQKSirZ8LJBYoJaW8aqL/v8LjyIWrVggBAgSAkLiQwngr+nivmcnQwxlkZkE+Uij5/F74zn33DvP887rVFXlrKJ33JdFv+ikj7ltCxWUg/JYhTt15Yt+0cUqfkhtWwFUGOETxpjWgzhCvugXKziPTfyMDQuyc8KoMME77OE19jEqB+U0D5qRT4pfwK/4Mx1badwk/WATD0jO9BRv8BAPUvsaw5yBHrMaXxWK/4G/cRsr6YJ3InVNoYcfhZA3cVUE9VHwmORBUscafsHddME+noio90TtNYU1Qfh33MAd7GIH+0W/mJaDsqqT38RPIsJtDPAIb8XD0xRWRcm+TedXcQv/CiGH0DtUMhtp0EVRaw/wD16mwU3Ue0ZXZJ7gdSm16+Yz4Ez5c0LxmyIDj/FCRP7p8BPeEKZFvzgQwu2KQFZEmc+m7nyyah7dB0F+T5RPk4ofxtTRef4zdFPbEYGs4ACvxAwzWvTv1iAW3r/rKCoR5VBE3TbxL6JOPuNUk85YRP5MYEm+LSzJt4Ul+bawJN8WluTbwndJvi2v5ptQ92Q64p3+nHYNp/+FrHx+j58I72ZTWi8esv7awsL7d81ttfdizXperGW3hOXXFvmv2o65bIZizfpYEL8i1L+Ag6Jf1K87aWT3bsvcdsw2yAy9clBWRb8Ypc5dkYF1XMdTEfGwfuEJI/s299KRPZxsO2KufCWcglciA5fxW+rbSX1NYk0ofk/YjmNhg2Tza+5VmpN/jvvCBrmGv4SbMNbcujY7GRtC8bFwyrYFv5ntuMglvit8witi6qRZ8nnKJhTfTsczHGQT7Gv+/LqaS9UwxqJUdkRJfygH5SR3nuadEY7ujozqtuNn5DlVe1J8YV/qWPJnBf8BBG3fAVKj0W4AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.48,
    y: 5.83,
    width: 37.66,
    height: 29.4,
    rx: 4.62
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-2",
    width: 27,
    height: 23,
    transform: "translate(10 11.9)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAXCAYAAAD6FjQuAAAACXBIWXMAAAsSAAALEgHS3X78AAADF0lEQVRIS63Wy28cRRAG8N8+bMexiU0MISRxIiFAERcgwlyQkCJO6z94R0JICE5cSFAEWQQCQRIHkBWTtZP4sY/hUDXe8e4GcaCkUffMVPXXVfVVdTfKsjQt251OI6fVCCV0i2LWIGWO3RmbRh0slZtoYwkLaVhigGMMukUxNiXbnU4z9ZfSHoY4wrBbFONTsJryKi7iMi6k4RB97GAXh92iGNWAWljG67iadiX28ABPMGiUZVkBLeMS3sK7uIk3sCg82sG3uItHeNEtinEN6Bpu5XNFRKKHL3M8aGfoFhLoI3yC97DprGe7wmMJ/ni70xkm0Ca2cBsf4jU8S917uUajiu2S2M2WANvMRcYmOVxJ3T08xN8YibBt4bMcr5nk+5Ucm3KRBlo4j1drCgfCm4YI5wWTnKyn/rII2+0a0Pm0aeZ4yui2SOQI+/hdEOOZIMQvAviDXKRiaRvnBPAtvC821DKJxoxUYTwSoflaePO2IMYLbKROtakTsWBLeHtZMPhAhHYt32fqsZkFNxT0/F6w53P8JAhxU5CnJcD7OBSA45zv4DvB1h1BoBlpQhbpSS70CL/mfAM3RC6bqXMoPBwJT+6LiHwhymJX0H7Ws2qSHla7JcJYdZBKd1Xk6bogxx/4Cl18IzZaeT0jVc6qwl4UebgoiPCXIMlI1M6aKPgHwvv7ohQaYiPXU3eutDHdQW7gTbG7O2K3W4KRGwL0iiiREs9zrUUv8aiSeR3k45zv4gfB0qt4R+SuTv+qSTMnR9Myr4N8Kor2Yf47EWArIm8V/Yf+A0Bd6h1kRXSISyJcq8KTUX5bF2Hqi1zum7Cufu69VOod5Lmotb4AWTcpzoUcnwpi9PCn2Xoq8xlPvWNC/WM8FkV5B7+JhY/yX1+E9V7q9MTGhrWTeyw8PUjbpzkf5D/tblGU253OQBDibhruiTydy/djEbpePj+LSNQ9qLpQz8SbH/PbEGX9pJ4+bdecPd73ReieCKDT60GN0Rui1qpzb/akrmTqHlHvHvU7yBDj6YtP2lanwb/fQWpG825W/A+3q38AG98zf3qvwcQAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12.1,26.12,15,25.77a2.81,2.81,0,0,0,.76,1.71,2.12,2.12,0,0,0,3-.12,2.72,2.72,0,0,0,.64-1.91,2.58,2.58,0,0,0-.61-1.81A2,2,0,0,0,17.37,23,5.27,5.27,0,0,0,16,23.2l.33-2.46a2.63,2.63,0,0,0,1.87-.53,1.89,1.89,0,0,0,.65-1.5A1.63,1.63,0,0,0,17.1,17a1.8,1.8,0,0,0-1.32.54,2.51,2.51,0,0,0-.67,1.57l-2.78-.48a6.17,6.17,0,0,1,.87-2.28A4,4,0,0,1,14.84,15a5.39,5.39,0,0,1,2.34-.49,4.67,4.67,0,0,1,3.57,1.42,3.59,3.59,0,0,1-1.16,5.93,3.66,3.66,0,0,1,2.16,1.3,3.76,3.76,0,0,1,.81,2.44,4.71,4.71,0,0,1-1.51,3.53,5.24,5.24,0,0,1-3.77,1.46,5.2,5.2,0,0,1-3.55-1.23A4.86,4.86,0,0,1,12.1,26.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.17,30.3h-3V18.93a10.46,10.46,0,0,1-3.9,2.29V18.48A8.85,8.85,0,0,0,27.82,17a5.57,5.57,0,0,0,1.9-2.52h2.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 9.88,
    y: 0.75,
    width: 4.89,
    height: 9.47,
    rx: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 29.28,
    y: 0.75,
    width: 4.89,
    height: 9.47,
    rx: 1.82
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarMaargIcon);
export default __webpack_public_path__ + "static/media/calendarMaargIcon.d527416b146a6fcaaca5710c4a1def2a.svg";
export { ForwardRef as ReactComponent };